
export default {
  name: 'FilterModal',
  props: {
    totalProducts: {
      default: 0,
      type: Number,
    },
  },
}
